export const AdSource = {
	UPLOAD:   'upload',
	ADSERVER: 'adserver',
	XML_URL:  'xml_url',
};
